import { SxProps, Theme } from "@mui/material/styles";

export const footerContainer: SxProps<Theme> = (theme) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(2),
    backgroundColor: "transparent",
    px: theme.spacing(2),
    py: theme.spacing(4),
    color: theme.palette.common.white,
});

export const footerItem: SxProps<Theme> = (theme) => ({
    margin: theme.spacing(1),
});

export const footerLinkContainer: SxProps<Theme> = (theme) => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(4),
});

export const footerLink: SxProps<Theme> = (theme) => ({
    color: theme.palette.common.white,
    fontFamily: "HsvSlab",
    fontWeight: "bold",
    textTransform: "uppercase",
    textDecoration: "none",
    fontSize: {
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
    },
    "&:hover": {
        textDecoration: "underline",
    },
});

export const footerImg: SxProps = {
    width: 200,
    objectFit: "contain",
};
